// plugins is a alias. see client/build/webpack.base.conf.js
// import http client
import { http } from '@/plugins/http/index';
import { getData } from '@/utils/get';

export const get = (payload = null) => http.post('apiSharedGrids/getSharedGrids', payload).then(getData);

export const getLink = (payload = null) => http.post('apiSharedGrids/getSelectedLink',payload).then(getData);